import React, { Component } from "react";
import styles from "./Layouts.local.scss";
import classnames from "classnames";

//  _________________________________
// |                                 |
// |                                 |
// |                                 |
// |                                 |
// |                                 |
// |_________________________________|

class QuestionsSlide extends Component {
  render() {
    const {
      //   // layoutData: { components },
      componentsBackground,
      currentOrganization
      //   // isResponsive,
      //   // isComposition
    } = this.props;

    const customBackground = {
      background: componentsBackground,
      transition: "all 5s ease"
    };

    let logo =
      currentOrganization && currentOrganization.avatarUrl
        ? currentOrganization.avatarUrl
        : null;
    let logoBlock = (
      <span
        className={classnames("boxes__box__logo", styles.deg_logo)}
        style={{ backgroundImage: `url(${logo})` }}
      />
    );

    return (
      <div className={`row ${styles.layout}`}>
        <div
          className={classnames(
            "large-12 medium-12 small-12",
            styles.component_block,
            styles.flex_container,
            styles.align_container
          )}
        >
          <div
            className={classnames(
              styles.component_container,
              styles.container_xl_height,
              styles.Thanking_slide
            )}
            style={customBackground}
          >
            {logoBlock}
            <h2 style={{ marginTop: 120 }}>Vous avez des questions ?</h2>
            <img
              src={"/img/Logo-Tamtam.png"}
              alt={""}
              className={styles.tamtam_logo}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default QuestionsSlide;



// WEBPACK FOOTER //
// ./src/components/Dashboard/Layouts/QuestionsSlide.js